import { render, staticRenderFns } from "./defaultFullWidth.vue?vue&type=template&id=74123c18"
import script from "./defaultFullWidth.vue?vue&type=script&lang=js"
export * from "./defaultFullWidth.vue?vue&type=script&lang=js"
import style0 from "./defaultFullWidth.vue?vue&type=style&index=0&id=74123c18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports